import { render, staticRenderFns } from "./adultEdu.vue?vue&type=template&id=90c6d2d2&scoped=true"
import script from "./adultEdu.vue?vue&type=script&lang=js"
export * from "./adultEdu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c6d2d2",
  null
  
)

export default component.exports